import { Map } from 'immutable';
import { createReducer } from 'redux-act';

import Guest from '@/models/interfaces/Guest';
import { companyGuestsFetched } from '@/store/actions/company/fetchCompanyGuests';

import Employee from '../../models/interfaces/Employee';
import PlaceName from '../../models/interfaces/PlaceName';
import { loggedInUserFetched } from '../actions/authentication/fetchLoggedInUser';
import { placeAdded } from '../actions/place/addPlace';
import { employeeDeleted } from '../actions/setting/company/deleteEmployee';
import { employeesFetched } from '../actions/setting/company/fetchEmployees';
import { employeesInvited } from '../actions/setting/company/inviteEmployees';
import { employeeModified } from '../actions/setting/company/modifyEmployee';

export interface CompanyReducerState {
  readonly employees: Map<string, Employee>;
  readonly companyPlaces: Map<string, PlaceName>;
  readonly guests: Guest[];
}

const defaultState: CompanyReducerState = {
  employees: Map<string, Employee>(),
  companyPlaces: Map<string, PlaceName>(),
  guests: [],
};

const companyReducer = createReducer<CompanyReducerState>({}, defaultState);

companyReducer.on(loggedInUserFetched, (state, { companyPlaces }) => ({
  ...state,
  companyPlaces: Map(companyPlaces.placeNames.map((placeName) => [placeName.uuid, placeName])),
}));

companyReducer.on(placeAdded, (state, { placeName }): CompanyReducerState => ({
  ...state,
  companyPlaces: state.companyPlaces.set(placeName.uuid, placeName),
}));

companyReducer.on(employeesFetched, (state, { employees }) => ({
  ...state,
  employees: Map(employees.map((employee) => [employee.userUuid, employee])),
}));

companyReducer.on(employeesInvited, (state, { employees }) => ({
  ...state,
  employees: employees.reduce((employeeMap, employee) => employeeMap.set(employee.userUuid, employee), state.employees),
}));

companyReducer.on(employeeModified, (state, { employee }) => ({
  ...state,
  employees: state.employees.set(employee.userUuid, employee),
}));

companyReducer.on(employeeDeleted, (state, { employee }) => ({
  ...state,
  employees: state.employees.delete(employee.userUuid),
}));

companyReducer.on(companyGuestsFetched, (state, { guests }) => ({
  ...state,
  guests,
}));

export default companyReducer;
